import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PrivateOutlet from "./layout/PrivateOutlet";
import PublicOutlet from "./layout/PublicOutlet";
import AddClient from "./pages/Client/Add";
import ListClient from "./pages/Client/List";
import Game from "./pages/Game/Game";
import Home from "./pages/Home";
import Login from "./pages/Login";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import store, { saveState } from "./redux/store";
import ChangePassword from "./pages/ChangePassword";
import CustomModal from "./components/UI/CustomModal";
import { createSocket } from "./utils/constants";
import AccountStatement from "./pages/Reports/AccountStatement";
import GeneralReport from "./pages/Reports/GeneralReport";
import ProfitLoss from "./pages/Reports/ProfitLoss";
import CasinoResult from "./pages/Reports/CasinoResult";
import CurrentBets from "./pages/Reports/CurrentBets";
import GameReport from "./pages/Reports/GameReport";
import MyProfitLoss from "./pages/MyProfitLoss";
import ActivityLog from "./pages/Client/Activity";
import BetHistory from "./pages/Reports/BetHistory";
import SecurityAuth from "./pages/securityAuth/SecurityAuth";
import Otp from "./pages/Otp";
import ChangePasswordNew from "./pages/ChangePasswordNew";
import TransactionPassword from "./pages/TransactionPassword";
import CommissionUserwiseReport from "./pages/Reports/CommissionUserwiseReport";
import CommissionReport from "./pages/Reports/CommissionReport";
import CasinoReport from "./pages/Reports/CasinoReport";
import UserRegisterDetail from "./pages/Reports/UserRegisterDetail";
import TotalProfitLoss from "./pages/Reports/TotalProfitLoss";
import MultiLogin from "./pages/Client/MultiLogin";
import GeneralLock from "./pages/Reports/GeneralLock";
import DTL20 from "./pages/Casino/DTL20";
import AAA from "./pages/Casino/AAA";
import MuflisTeenpatti from "./pages/Casino/MuflisTeenpatti";
import TeenpattiOneDay from "./pages/Casino/TeenpattiOneDay";
import OneDayDragonTiger from "./pages/Casino/OneDayDragonTiger";
import Lucky7A from "./pages/Casino/Lucky7A";
import Challenge from "./pages/Challenge";
import { isTechAdmin } from "./utils/permissions";

export default function App() {
  const userData = useSelector((state) => state.account.userData);
  const ui = useSelector((state) => state.account.ui);
  const dispatch = useDispatch();
  const location = useLocation();
  // A Redux token can briefly be stale while an in-flight request finishes.
  // The durable token is removed during logout, so both values are required
  // before private routes may render.
  const hasAuthenticatedSession = Boolean(
    userData.token && window.localStorage.getItem("token")
  );

  useEffect(() => {
    store.subscribe(() => {
      saveState(store.getState());
    });
  }, [0]);
  return (
    <>
      {hasAuthenticatedSession && !userData.resetRequired ? (
        <PrivateOutlet>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/manage-client/list" element={<ListClient />} />
            <Route
              path="/admin/manage-client/list/:username/:id"
              element={<ListClient />}
            />
            <Route
              path="/admin/manage-client/active-list"
              element={<ListClient activeuser={true} />}
            />
            <Route path="/admin/manage-client/add" element={<AddClient />} />
            <Route path="/admin/createaccount" element={<MultiLogin />} />
            <Route path="/admin/settings/userlock" element={<GeneralLock />} />
            <Route path="/admin/game/:game/:id" element={<Game />} />
            <Route path="/admin/live-market/dt20" element={<DTL20 />} />
            <Route path="/admin/live-market/aaa" element={<AAA />} />
            <Route path="/admin/live-market/muflis" element={<MuflisTeenpatti />} />
            <Route path="/admin/live-market/teenpatti" element={<TeenpattiOneDay />} />
            {/* <Route path="/admin/live-market/dt" element={<OneDayDragonTiger />} />
            <Route path="/admin/live-market/lucky7" element={<Lucky7A />} /> */}
            <Route
              path="/admin/reports/account-statement"
              element={<AccountStatement />}
            />
            <Route
              path="/admin/reports/general-report"
              element={<GeneralReport />}
            />
            <Route path="/admin/reports/profit-loss" element={<ProfitLoss />} />
            <Route
              path="/admin/reports/casino-results"
              element={<CasinoResult />}
            />
            <Route
              path="/admin/reports/current-bet"
              element={<CurrentBets />}
            />
            <Route path="/tp" element={<TransactionPassword />} />
            <Route path="/admin/reports/bet-history" element={<BetHistory />} />
            <Route path="/admin/reports/game-report" element={<GameReport />} />
            <Route
              path="/admin/reports/livecasinoreport"
              element={<CasinoReport />}
            />
            <Route
              path="/admin/reports/userregisterdetail"
              element={<UserRegisterDetail />}
            />
            <Route
              path="/admin/reports/totalprofitloss"
              element={<TotalProfitLoss />}
            />
            <Route
              path="/admin/reports/commission-userwise-report"
              element={<CommissionUserwiseReport />}
            />
            <Route
              path="/admin/reports/commission-report"
              element={<CommissionReport />}
            />
            <Route
              path="/admin/change-password"
              element={<ChangePassword internal={true} />}
            />
            <Route path="/admin/market-analysis" element={<MyProfitLoss />} />
            <Route
              path="/admin/activity-log/:username"
              element={<ActivityLog />}
            />
            <Route path="/admin/security" element={<SecurityAuth />} />
            <Route
              path="/admin/challenges"
              element={
                isTechAdmin(userData) ? <Challenge /> : <Navigate to="/" replace />
              }
            />
          </Routes>
        </PrivateOutlet>
      ) : hasAuthenticatedSession && userData.resetRequired ? (
        <PublicOutlet>
          <Routes>
            <Route path="/tp" element={<TransactionPassword />} />
            <Route path="*" element={<ChangePasswordNew internal={true} />} />
            <Route path="/" element={<ChangePasswordNew internal={true} />} />
          </Routes>
          <CustomModal header={ui?.modalHeader} isOpen={ui?.modalOpen} />
        </PublicOutlet>
      ) : (
        <PublicOutlet>
          <Routes>
            <Route>
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Login />} />
              <Route path="/otp" element={<Otp />} />
            </Route>
          </Routes>
        </PublicOutlet>
      )}
      <CustomModal header={ui?.modalHeader} isOpen={ui?.modalOpen} />
    </>
  );
}
